import React from 'react';
import { Box, MenuItem, Select } from '@mui/material';
import { useTranslation } from '../i18n/TranslationContext';

/** Selettore lingua: compare solo se c'è più di una lingua abilitata */
const LanguageSelector: React.FC<{ sx?: object }> = ({ sx }) => {
  const { lang, setLang, languages } = useTranslation();

  if (languages.length < 2) return null;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', ...sx }}>
      <Select
        size="small"
        value={lang ?? languages.find(l => l.is_default)?.code ?? languages[0].code}
        onChange={e => setLang(e.target.value)}
        sx={{ minWidth: 130, backgroundColor: 'background.paper' }}
      >
        {languages.map(l => (
          <MenuItem key={l.code} value={l.code}>
            {l.flag ? `${l.flag} ` : ''}{l.name}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default LanguageSelector;
